var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_request-form" },
    [
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center px-2 p-lg-5 mt-2",
              attrs: { lg: "12" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "12", md: "8", lg: "6" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-card-title",
                        {
                          staticClass: "mb-1 font-weight-bold text-center",
                          attrs: { "title-tag": "h2" }
                        },
                        [_vm._v(" Olá, bem-vindo(a)! ")]
                      ),
                      !_vm.headerDescription
                        ? _c("b-card-text", { staticClass: "mb-2" }, [
                            _vm._v(
                              " Este formulário foi construído para você solicitar seus direitos em relação aos seus dados pessoais."
                            ),
                            _c("br"),
                            _c("br")
                          ])
                        : _vm._e(),
                      _vm.headerDescription
                        ? _c("b-card-text", {
                            directives: [
                              {
                                name: "html-safe",
                                rawName: "v-html-safe",
                                value: _vm.headerDescription,
                                expression: "headerDescription"
                              }
                            ],
                            staticClass: "mb-2"
                          })
                        : _vm._e(),
                      _c(
                        "validation-observer",
                        { ref: "requestForm" },
                        [
                          _c(
                            "b-form",
                            {
                              staticClass: "mb-1 mt-2",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.send($event)
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Solicitante",
                                    "label-for": "request_type"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Solicitante",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-radio-group", {
                                              attrs: {
                                                options: _vm.requestTypeList,
                                                name: "request_type",
                                                stacked: ""
                                              },
                                              model: {
                                                value: _vm.requestType,
                                                callback: function($$v) {
                                                  _vm.requestType = $$v
                                                },
                                                expression: "requestType"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Natureza do vínculo",
                                    "label-for": "request_bond_type"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Natureza do vínculo",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-radio-group", {
                                              attrs: {
                                                options:
                                                  _vm.requestBondTypeList,
                                                "value-field": "id",
                                                "text-field": "name",
                                                name: "request_bond_type",
                                                stacked: ""
                                              },
                                              model: {
                                                value: _vm.requestBondTypeId,
                                                callback: function($$v) {
                                                  _vm.requestBondTypeId = $$v
                                                },
                                                expression: "requestBondTypeId"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Unidade",
                                    "label-for": "legal_person"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Unidade",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                staticClass: "required-select",
                                                attrs: {
                                                  options: _vm.listLegal,
                                                  label: "name"
                                                },
                                                model: {
                                                  value: _vm.legalEntity,
                                                  callback: function($$v) {
                                                    _vm.legalEntity = $$v
                                                  },
                                                  expression: "legalEntity"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "no-options"
                                                    },
                                                    slot: "no-options"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Nenhum registro encontrado!"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Solicitação",
                                    "label-for": "request_category"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Solicitação",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                staticClass:
                                                  "required-select multiple",
                                                attrs: {
                                                  clearable: true,
                                                  multiple: "",
                                                  dir: "ltr",
                                                  "deselect-from-dropdown": "",
                                                  options:
                                                    _vm.requestCategoryList,
                                                  label: "name"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key:
                                                        "selected-option-container",
                                                      fn: function(ref) {
                                                        var option = ref.option
                                                        var deselect =
                                                          ref.deselect
                                                        var multiple =
                                                          ref.multiple
                                                        var disabled =
                                                          ref.disabled
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover",
                                                                  modifiers: {
                                                                    hover: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "flex flex-row items-center",
                                                              attrs: {
                                                                title:
                                                                  option.description
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "vs__selected"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      option.name
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "feather-icon",
                                                                    {
                                                                      staticClass:
                                                                        "cursor-pointer h-5 w-5",
                                                                      attrs: {
                                                                        icon:
                                                                          "XIcon",
                                                                        size:
                                                                          "12"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return (function() {
                                                                            return _vm.removeCategorySelect(
                                                                              option.id
                                                                            )
                                                                          })(
                                                                            $event
                                                                          )
                                                                        }
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: _vm.requestCategory,
                                                  callback: function($$v) {
                                                    _vm.requestCategory = $$v
                                                  },
                                                  expression: "requestCategory"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "no-options"
                                                    },
                                                    slot: "no-options"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Nenhum registro encontrado!"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Nome",
                                    "label-for": "person_name"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "Nome", rules: "required" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "person_name",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                name: "person_name"
                                              },
                                              model: {
                                                value: _vm.personName,
                                                callback: function($$v) {
                                                  _vm.personName = $$v
                                                },
                                                expression: "personName"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              !_vm.isAnpd
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-row flex-wrap gap-1"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "flex-grow w-full text-sm"
                                            },
                                            [_vm._v("Documento")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center pb-1 select-none"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  class: [
                                                    _vm.isCpf
                                                      ? "text-primary font-bold"
                                                      : "",
                                                    "mb-0 pr-1"
                                                  ]
                                                },
                                                [_vm._v("CPF")]
                                              ),
                                              _c("b-form-checkbox", {
                                                staticClass:
                                                  "custom-control-secondary",
                                                attrs: {
                                                  name: "check-button",
                                                  switch: ""
                                                },
                                                model: {
                                                  value: _vm.isCpf,
                                                  callback: function($$v) {
                                                    _vm.isCpf = $$v
                                                  },
                                                  expression: "isCpf"
                                                }
                                              }),
                                              _c(
                                                "label",
                                                {
                                                  class: [
                                                    _vm.isCpf
                                                      ? ""
                                                      : "text-primary font-bold",
                                                    "mb-0 "
                                                  ]
                                                },
                                                [_vm._v("CRNM (RNE)")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm.isCpf
                                        ? _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                "label-for": "person_document"
                                              }
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "CPF",
                                                  rules: "required|cpf"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            directives: [
                                                              {
                                                                name: "mask",
                                                                rawName:
                                                                  "v-mask",
                                                                value:
                                                                  "###.###.###-##",
                                                                expression:
                                                                  "'###.###.###-##'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "required",
                                                            attrs: {
                                                              id:
                                                                "person_document",
                                                              state:
                                                                errors.length >
                                                                0
                                                                  ? false
                                                                  : null,
                                                              name:
                                                                "person_document"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.personDocument,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.personDocument = $$v
                                                              },
                                                              expression:
                                                                "personDocument"
                                                            }
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3868643570
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                "label-for": "person_document"
                                              }
                                            },
                                            [
                                              _c("validation-provider", {
                                                attrs: {
                                                  name: "CRNM (RNE)",
                                                  rules: "required"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("b-form-input", {
                                                            directives: [
                                                              {
                                                                name: "mask",
                                                                rawName:
                                                                  "v-mask",
                                                                value: "X".repeat(
                                                                  32
                                                                ),
                                                                expression:
                                                                  "'X'.repeat(32)"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "required",
                                                            attrs: {
                                                              id:
                                                                "person_document",
                                                              state:
                                                                errors.length >
                                                                0
                                                                  ? false
                                                                  : null,
                                                              name:
                                                                "person_document"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.personDocument,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.personDocument = $$v
                                                              },
                                                              expression:
                                                                "personDocument"
                                                            }
                                                          }),
                                                          _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3330049906
                                                )
                                              })
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isAnpd
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "CNPJ",
                                        "label-for": "person_document"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "CNPJ",
                                          rules: "required|cnpj"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    directives: [
                                                      {
                                                        name: "mask",
                                                        rawName: "v-mask",
                                                        value:
                                                          "##.###.###/####-##",
                                                        expression:
                                                          "'##.###.###/####-##'"
                                                      }
                                                    ],
                                                    staticClass: "required",
                                                    attrs: {
                                                      id: "person_document",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null,
                                                      name: "person_document"
                                                    },
                                                    model: {
                                                      value: _vm.personDocument,
                                                      callback: function($$v) {
                                                        _vm.personDocument = $$v
                                                      },
                                                      expression:
                                                        "personDocument"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          190717042
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.isAnpd
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Data Nascimento",
                                        "label-for": "birth_date"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "Data Nascimento",
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("flat-pickr", {
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      config: _vm.configCalendar
                                                    },
                                                    model: {
                                                      value: _vm.birth_date,
                                                      callback: function($$v) {
                                                        _vm.birth_date = $$v
                                                      },
                                                      expression: "birth_date"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          634069154
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Email",
                                    "label-for": "email"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Email",
                                      vid: "email",
                                      rules: "required|email"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-input-group",
                                              {
                                                staticClass: "input-group-merge"
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "required",
                                                  attrs: {
                                                    id: "email",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name: "email",
                                                    placeholder:
                                                      "joao@exemplo.com"
                                                  },
                                                  model: {
                                                    value: _vm.personEmail,
                                                    callback: function($$v) {
                                                      _vm.personEmail = $$v
                                                    },
                                                    expression: "personEmail"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Telefone",
                                    "label-for": "person_phone"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Telefone",
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              directives: [
                                                {
                                                  name: "mask",
                                                  rawName: "v-mask",
                                                  value: [
                                                    "(##)####-####",
                                                    "(##)#####-####"
                                                  ],
                                                  expression:
                                                    "['(##)####-####', '(##)#####-####']"
                                                }
                                              ],
                                              staticClass: "required",
                                              attrs: {
                                                id: "person_document",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                name: "person_phone"
                                              },
                                              model: {
                                                value: _vm.personPhone,
                                                callback: function($$v) {
                                                  _vm.personPhone = $$v
                                                },
                                                expression: "personPhone"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "País",
                                    "label-for": "country"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: { name: "País", rules: "required" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                staticClass: "required-select",
                                                attrs: {
                                                  options: _vm.countryList,
                                                  label: "name_pt"
                                                },
                                                model: {
                                                  value: _vm.country,
                                                  callback: function($$v) {
                                                    _vm.country = $$v
                                                  },
                                                  expression: "country"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "no-options"
                                                    },
                                                    slot: "no-options"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Nenhum registro encontrado!"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("privacy_form_description"),
                                    "label-for": "description"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: "Descrição da solicitação",
                                      rules: "min:10|max:65535"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-textarea", {
                                              attrs: {
                                                id: "description",
                                                state: errors.length
                                                  ? false
                                                  : null,
                                                placeholder: _vm.$t(
                                                  "privacy_form_min_caracter"
                                                ),
                                                rows: "4",
                                                maxlength: "65535"
                                              },
                                              model: {
                                                value: _vm.description,
                                                callback: function($$v) {
                                                  _vm.description = $$v
                                                },
                                                expression: "description"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vx-row pt-2 justify-content-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col" },
                                    [
                                      _c(
                                        "vue-dropzone",
                                        {
                                          ref: "fileUploadZone",
                                          attrs: {
                                            id: "upload",
                                            "use-font-awesome": true,
                                            options: _vm.dropzoneOptions,
                                            "use-custom-dropzone-options": true,
                                            "validation-allowed-extensions": [
                                              ".pdf",
                                              ".doc",
                                              ".docx",
                                              ".jpg",
                                              ".jpeg",
                                              ".png"
                                            ],
                                            useCustomSlot: true
                                          },
                                          on: {
                                            "vdropzone-success":
                                              _vm.successSendFormWithFile,
                                            "vdropzone-sending":
                                              _vm.sendFormWithFile,
                                            "vdropzone-error": _vm.error,
                                            "vdropzone-file-added": [
                                              _vm.added,
                                              _vm.fileAdded
                                            ],
                                            "vdropzone-queue-complete":
                                              _vm.complete
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropzone-custom-content"
                                            },
                                            [
                                              _vm._v(
                                                " Arraste e solte para enviar um arquivo "
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "separator" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "separator-span"
                                                    },
                                                    [_vm._v(" ou ")]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btn waves-effect outline-primary",
                                                  attrs: {
                                                    type: "button",
                                                    variant: "outline-secondary"
                                                  }
                                                },
                                                [_vm._v("Selecionar")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-col w-full" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "waves-effect float-right",
                                        attrs: {
                                          type: "submit",
                                          variant: "primary"
                                        }
                                      },
                                      [_vm._v(" Enviar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-card-footer",
                        { staticClass: "text-right" },
                        [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Desenvolvido por:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "https://securamdata.com",
                                target: "_brank"
                              }
                            },
                            [_vm._v("securamdata.com")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            width: "550px",
            title: "Procotolo",
            "ok-only": "",
            centered: ""
          },
          model: {
            value: _vm.activeDialogAge,
            callback: function($$v) {
              _vm.activeDialogAge = $$v
            },
            expression: "activeDialogAge"
          }
        },
        [
          _c("div", { staticClass: "con-content" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.protocolNumber) + " ")]),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.msgDescription) } }),
            _c("p", [
              _vm._v(" Link Portal Privacidade: "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.linkPrivacy,
                    target: "_blank",
                    rel: "privacy"
                  }
                },
                [_vm._v(_vm._s(_vm.linkPrivacy))]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }